module.exports = __webpack_public_path__ + "static/img/中金logo.b71a4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/中金logo.png
// module id = wO34
// module chunks = 1